import { RecurringEventFrequency } from '@tribeplatform/gql-client/types'

import { I18nShape } from '../../../../i18n/types.js'

export const recurrenceBadgeTextFactory = (
  intl: I18nShape,
  frequency: RecurringEventFrequency,
) => {
  switch (frequency) {
    case RecurringEventFrequency.daily:
      return intl.$t({
        id: 'Event.Recurrence.Badge.Daily',
        defaultMessage: 'Repeats daily',
      })
    case RecurringEventFrequency.weekly:
      return intl.$t({
        id: 'Event.Recurrence.Badge.Weekly',
        defaultMessage: 'Repeats weekly',
      })
    case RecurringEventFrequency.monthly:
      return intl.$t({
        id: 'Event.Recurrence.Badge.Monthly',
        defaultMessage: 'Repeats monthly',
      })
    case RecurringEventFrequency.yearly:
      return intl.$t({
        id: 'Event.Recurrence.Badge.Yearly',
        defaultMessage: 'Repeats yearly',
      })
    case RecurringEventFrequency.once:
      return null
    default: {
      const _exhaustiveCheck: never = frequency
      return _exhaustiveCheck
    }
  }
}
